export const fetchIndicator = {
  pathname: ({ type, value }) => {
    return `/api/v4/indicator/${type}${value === undefined ? '' : `/${encodeURIComponent(value)}`}`
  },
  search: ({
    explainer = true,
    includeAttribution = true,
    includeCategory = true,
    includeThreatRating,
    includeReports = true,
  } = {}) => ({
    explainer,
    include_attribution: includeAttribution,
    include_category: includeCategory,
    include_threat_rating: includeThreatRating,
    include_reports: includeReports,
  })
}

export const fetchIndicatorById = {
  pathname: ({ id }) => {
    return `/api/v4/indicator/${id}`
  },
  search: ({
    explainer = true,
    includeAttribution = true,
    includeCategory = true,
    includeThreatRating,
    includeReports = true,
  } = {}) => ({
    explainer,
    include_attribution: includeAttribution,
    include_category: includeCategory,
    include_threat_rating: includeThreatRating,
    include_reports: includeReports,
  })
}

export const fetchActorIndicators = {
  pathname: (id) => `/api/v4/actor/${id}/indicators`
}

export const fetchCampaignIndicators = {
  pathname: ({ id }) => `/api/v4/campaign/${id}/indicators`,
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: ({ options }) => JSON.stringify(options)
}

export const fetchMalwareIndicators = {
  pathname: ({ id }) => `/api/v4/malware/${id}/indicators`,
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: ({ options }) => JSON.stringify(options)
}

export const download = {
  pathname: '/api/v4/indicator/download',
  headers: {
    'Content-Type': 'application/json',
    accept: 'text/csv'
  },
  method: 'POST',
  body: body => {
    if (typeof body !== 'object' || body === null) {
      throw new Error('indicator.download requires an object')
    }
    return body
  }
}

export const fetchFilteredIndicatorsByTypeAndId = {
  pathname: ({ type, id }) => `/api/v4/${type}/${id}/indicators`,
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'content-type': 'application/json',
  },
  body: ({
    attribution,
    filters,
    includeThreatRating,
    includeReports,
    limit = 100,
    offset = 0,
    search,
    sortBy = [],
    sortOrder = 'desc',
  }) => ({
    attribution,
    filters,
    include_threat_rating: includeThreatRating,
    include_reports: includeReports,
    limit,
    offset,
    search,
    sort_by: sortBy,
    sort_order: sortOrder,
  })
}

export const testIndicators = {
  pathname: ({ type, id }) => `/api/v4/${type}/${id}/indicators?limit=1&enable_next_pagination=false`,
  onResponse: async res => {
    if (res.status !== 200) {
      return false
    }
    try {
      const data = await res.json()
      return !!data.indicators.length
    } catch {
      return false
    }
  }
}

export const fetchIndicators = {
  pathname: '/api/v4/indicator',
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: (request) => JSON.stringify(request)
}

export const fetchIndicatorDetails = {
  pathname: ({ type, value }) => `/api/v4/indicator/${type}/${encodeURIComponent(value)}`,
  search: ({ search }) => search,
}

export const fetchIndicatorDetailsWithType = {
  pathname: ({ type }) => `/api/v4/indicator/${type}`,
  search: ({ search }) => search,
}
